import { Dropdown } from 'antd';
import React from 'react';

const HeaderDropdown = (restProps) => <Dropdown {...restProps} />;
export default HeaderDropdown;
